


















import Component from 'vue-class-component';
import {Prop, Vue} from 'vue-property-decorator';

@Component
export default class Modal extends Vue {
    @Prop()
    title!: string;

    /**
     * When the modal is shown, we want a fixed body so that no background scrolling can happen
     */
    private mounted() {
        document.body.style.top = `-${window.scrollY}px`;
        document.body.style.position = 'fixed';
        document.body.style.width = '100vw';
        // document.body.style.paddingRight = '15px'; /* Avoid width reflow when scrollbar disappears */

        window.addEventListener('keyup', this.onKeyUp);
    }
    /**
     * When the modal is hidden we need to remember the current scroll position, reset the body styling, and
     * scroll back to that position (since by default the body will forget its
     * Y when resetting the position and top attrs)
     */
    private beforeDestroy() {
        window.removeEventListener('keyup', this.onKeyUp);
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.paddingRight = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }

    onKeyUp(e: KeyboardEvent) {
        if (e.key === 'Escape') {
            this.$emit('close');
        }
    }

    get topOffset(): number {
        return window.scrollY;
    }
}
